// removed by extract-text-webpack-plugin
module.exports = {"step":"index__step--tZrC0","step-content":"index__step-content--2WRQc","step-optional":"index__step-optional--2lnpy","warningIcon":"index__warningIcon--1q6iU","btn":"index__btn--27Cc9","circularProgressMargin":"index__circularProgressMargin--3sky7","circularProgressColor":"index__circularProgressColor--XBNhQ"};


//////////////////
// WEBPACK FOOTER
// ./src/client/shared-components/Wizard/styles/index.scss
// module id = zXdC
// module chunks = 23